export default __webpack_public_path__ + "static/media/logo.0131f29c.png";